var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FB3C6C",
    d: "m12 13.05-5.075 5.075a.736.736 0 0 1-.512.212.69.69 0 0 1-.538-.212.72.72 0 0 1-.225-.525c0-.2.075-.375.225-.525L10.95 12 5.875 6.925a.737.737 0 0 1-.212-.513.69.69 0 0 1 .212-.537.72.72 0 0 1 .525-.225c.2 0 .375.075.525.225L12 10.95l5.075-5.075a.74.74 0 0 1 .513-.213.693.693 0 0 1 .537.213.72.72 0 0 1 .225.525.72.72 0 0 1-.225.525L13.05 12l5.075 5.075a.736.736 0 0 1 .212.512.69.69 0 0 1-.212.538.72.72 0 0 1-.525.225.72.72 0 0 1-.525-.225L12 13.05Z"
  })));
};
export default SvgClose;